function validateAuthToken(
  token: string,
  other?: HeadersInit | null,
  objectWhileFail?: boolean
): HeadersInit {
  return token && token !== "undefined" && token.length > 0
    ? {
        Authorization: `Bearer ` + token,
        ...other,
      }
    : !objectWhileFail
    ? null
    : { ...other };
}

export default validateAuthToken;
